import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';


const styles = theme => ({
  iconHover: {
    margin: theme.spacing.unit * 2,
    flex: 1,
    textAlign: 'right'
  },
  actions: {
    display: 'flex',
  },
  divider: {
    marginRight: 20,
    marginLeft: 20
  },
});

export class DashBoardWidget extends Component {
  render() {
    const iconSize = 45;
    const { classes, iconColor, icon, title, subtitleColor, subtitle } = this.props;
    return (
      <Card>
        <Grid container>
          <Grid item xs={12} lg={4}>
          <Icon className={classes.iconHover} style={{ fontSize: iconSize, color: iconColor }}>
            {icon}
          </Icon>
          </Grid>
          <Grid item xs={12} lg={8}>
            <CardContent>
              <Typography align="right" variant="caption">{title}</Typography>
              <Typography align="right" variant="title" color={subtitleColor}>
                {subtitle}
              </Typography>
            </CardContent>
          </Grid>
        </Grid>
        <Divider className={classes.divider} />
        <CardActions className={classes.actions} disableActionSpacing>
          {this.props.children}
        </CardActions>
      </Card>
    );
  }
}
DashBoardWidget.defaultProps = {
  iconColor: 'red',
  icon: 'error',
  title: 'Title',
  subtitleColor: 'default',
  subtitle: 'Subtitle',
  onClick: () => console.log()
};

export default withStyles(styles)(DashBoardWidget);



// WEBPACK FOOTER //
// ./src/components/home/DashBoardWidget.js